import api from "@/services/api";

import { TransactionType } from "@/types/sale/Sale";

class GetTransactionStatus {
  execute = async (transactionId: string) => {
    const transaction = await api().get(`/transaction/${transactionId}`);
    return transaction.data as TransactionType;
  };
}

export { GetTransactionStatus };
